import React, { useState } from 'react';
import EndOfWeek from '../../components/myTrack/EndOfWeek';

export default function WeekManagement() {
    const [successMessage, setSuccessMessage] = useState('');
    const [failMessage, setFailMessage] = useState('');

    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-2xl mx-auto">
                <div className="mb-6">
                    <h1 className="text-xl font-bold text-brand-secondary">Week Management</h1>
                    <p className="text-sm text-gray-500 mt-1">Close the current system week and advance to the next billing period.</p>
                </div>

                {successMessage && (
                    <div className="mb-4 px-4 py-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700">
                        {successMessage}
                    </div>
                )}
                {failMessage && (
                    <div className="mb-4 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
                        {failMessage}
                    </div>
                )}

                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                    <EndOfWeek
                        setSuccessMessage={setSuccessMessage}
                        setFailMessage={setFailMessage}
                    />
                </div>
            </div>
        </div>
    );
}
